var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHourglass = function SvgHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.4,
    d: "M14 3.167h-1.333V5.5c0 .148-.05.292-.14.41L10.511 8.5l2.014 2.59c.091.118.141.262.141.41v2.333H14v1.334H2v-1.334h1.333V11.5c0-.148.05-.292.14-.41L5.489 8.5 3.474 5.91a.67.67 0 0 1-.141-.41V3.167H2V1.833h12zM4.667 5.271l2.192 2.82a.67.67 0 0 1 0 .818l-2.192 2.82v2.104h6.666v-2.104l-2.192-2.82a.666.666 0 0 1 0-.818l2.192-2.82V3.167H4.667zm5 7.229H6.333v-1.333h3.334zm.026-6.59-1.167 1.5a.667.667 0 0 1-1.052 0l-1.167-1.5 1.052-.82.641.824.64-.823z"
  })));
};
export default SvgHourglass;